module.exports = __webpack_public_path__ + "static/media/84.1d3be476.gif";